export { default } from './InputMask';


// WEBPACK FOOTER //
// ./src/components/shared/InputMask/index.ts